// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  version: '3.1.5.0',
  baseUrl: 'https://connect.stg.crewdle.ai/',
  maxParticipants: 100,
  firebaseConfig: {
    apiKey: 'AIzaSyDHDgmA574NVeMWV9SpW-q4QQMjkANuueg',
    authDomain: 'crewdle-sdk-stg.firebaseapp.com',
    databaseURL: 'https://crewdle-sdk-stg-default-rtdb.firebaseio.com',
    projectId: 'crewdle-sdk-stg',
    storageBucket: 'crewdle-sdk-stg.firebasestorage.app',
    appId: '1:519415702791:web:5dd39042f881cfde3251a2',
    measurementId: 'G-65GE57FYE4',
  },
  recaptcha: {
    recaptchaSiteKey: '6LejBbccAAAAAPIhLWXqmS8YI0qPIGhx7NdyC-7r',
  },
  segment: {
    key: 'Hej6ui3Rw7pMkff94f6kRVfZff6fGp0E',
  },
  datadog: {
    appId: '9b7673c8-7da7-45d9-ba45-c4b29378b70d',
    token: 'pub12f6369ccd7f8b17b19bb49984c0eacf',
  },
  adminConsoleUrl: 'https://admin.stg.crewdle.ai',
  apiUrl: 'https://api.stg.crewdle.ai',
  mcpUrl: 'https://mcp.stg.crewdle.ai',
  ai: {
    proxyUrl: 'https://api.stg.crewdle.ai',
    model: 'gpt-5.4',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
